import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectObject } from '../brands.model';
import { LanguageService } from 'src/app/services/language.service';
import { RouterUrls } from '../router-urls';
import { Router } from '@angular/router';

@Component({
  selector: 'app-brand-impact-popup',
  templateUrl: './brand-impact-popup.component.html',
  styleUrls: ['./brand-impact-popup.component.scss']
})
export class BrandImpactPopupComponent implements OnInit {

  RouterUrls = RouterUrls;
  projects: ProjectObject[];
  sortedProjects = {};
  impactAxis = [];
  allImpact: boolean;
  correspondingAxis: string[];

  constructor(private dialogRef: MatDialogRef<BrandImpactPopupComponent>,
              private languageService: LanguageService,
              private router: Router,
              @Inject(MAT_DIALOG_DATA) data) {
                this.projects = data.projects;
                this.allImpact = data.allImpact;
                this.correspondingAxis = data.correspondingAxis;
                this.sortProjectsByAxis();
  }

  ngOnInit() {}

  sortProjectsByAxis() {
    if (this.allImpact) {
      for (const project of this.projects) {
        if (project.north_star in this.sortedProjects) {
          this.sortedProjects[project.north_star].push(project);
        } else {
          this.sortedProjects[project.north_star] = [project];
          this.impactAxis.push(project.north_star);
        }
      }
    } else {
      for (const project of this.projects) {
        if (this.correspondingAxis.includes(project.north_star)) {
          if (project.north_star in this.sortedProjects) {
            this.sortedProjects[project.north_star].push(project);
          } else {
            this.sortedProjects[project.north_star] = [project];
            this.impactAxis.push(project.north_star);
          }
        }
      }
    }
  }

  goToProject(slug: string) {
    const url = this.languageService.getCurrentLangWithSlash() + '/' + RouterUrls.BrowseProjects + '/' + slug;
    window.open(url, '_blank');
  }

  roundImpact(value: number) {
    if (value < 0.005) {
      return '0.01';
    } else {
      return value.toFixed(2);
    }
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: [] });
  }

  get currentLanguage() {
    return this.languageService.getUserUsedLanguage();
  }
}
